import React,  { useRef } from "react";
import headerImage from "../../assets/header4.jpg";
import { CopyBlock, dracula } from "react-code-blocks";
import w10_1 from "../../assets/w10_1.jpg";
import w10_2 from "../../assets/w10_2.jpg";
import output from "../../assets/output.mp4";
import w10_3 from "../../assets/w10_3.jpg";


const Assignment12 = () => {
  const i2c = useRef(null);
  const display = useRef(null);
  const motordriver = useRef(null);

  const scrollToSection = (ref) => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };


    
  return (

    <div className="container mx-auto my-8 px-5 max-w-3xl bg-gray-100 p-8 rounded-lg shadow-md">
      {/* Header */}
      <div className="relative mb-8">
        <img
          src={headerImage}
          alt="Header"
          className="w-full h-64 object-cover rounded-lg shadow-md  object-cover filter grayscale brightness-75"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-4 rounded-b-lg">
          <h1 className="text-4xl font-bold text-bg-secondary"  style={{ textShadow: '2px 2px 4px rgba(0, 0, 0, 1)' }}>Week 11: Networking and Communication</h1>
          <p className="text-gray-300 mt-2">Published on: <span className="font-semibold">April 24, 2025</span></p>
          <div className="mt-4 flex space-x-4">
         {/* Navigation Links */}


        </div>
        </div>
        </div>
        <p className="text-justify text-gray-700 mb-6">
  In this week’s assignment, the focus was on <strong>output devices</strong> — components that allow a microcontroller to communicate with the outside world by producing a visual, audible, or mechanical response. This can include anything from LEDs and motors to speakers and displays.
</p>
<div className="text-gray-700 space-y-4 mt-6">

<p className="text-justify text-gray-700 mb-6">
  The goal was to connect and control at least one output device using a board we previously designed or modified. In my case, I continued working with my custom ESP32S3 Plus-based development board and chose to explore an <strong>I2C LCD display</strong> as an output device. 
</p>
<p className="text-justify text-gray-700 mb-4">
        As always you will find our group assignment on our
        <a 
          href="https://fabacademy.org/2025/labs/bottrop/Assignments/week11/" 
          className="text-blue-500 underline ml-1" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          group documentation page 
        </a>. This week, we measured the power consumption of an LED strip depending on the color output.
      </p>
      <p className="text-justify text-gray-700 mb-4">
        I used my development board I produced for  
        <a 
          href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/assignments/10" 
          className="text-blue-500 underline ml-1" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          input week
        </a>.
      </p>

        {/* XYZ Section*/}
        <div ref={motordriver}></div>
        <h2 className="text-2xl font-bold text-left mb-2">Stepper Motor & Motor Driver</h2>
        <p className="text-justify text-gray-700 mb-6">

...
      </p>
      <img src={w10_3} alt="" className="my-4 mx-auto rounded shadow-md" />
      <h2 className="text-2xl font-bold text-left mb-2">Downloads</h2>

      <a
    style={{ display: "block" }}
    href="https://fabacademy.org/2025/labs/bottrop/students/annasophia-brokuf/files/Ultrasonic_Sketch_with_Display.ino"
    download
  >
    📎 Download Code
  </a>
        </div>

</div>

  );
};

export default Assignment12;
